import uniq from 'lodash-es/uniq';
import {
    HOME_LOAD_API_SUCCESS, HOME_LOAD_PAGE_API_SUCCESS,
    HomeLoadApiSuccessAction,
    HomeLoadPageApiSuccessAction,
} from 'mk2/apps/home/containers/Home/Home.actions';
import { initialState } from 'mk2/apps/home/containers/Home/Home.constants';
import { errorMessageFiltered } from 'mk2/reducers/errorMessage';
import { LoadingState, loadingStateFiltered } from 'mk2/reducers/loadingState';
import { combineReducers, Reducer } from 'redux';

export interface BazaarCounts {
    prams: number;
    footwear: number;
    toys: number;
    others: number;
}

export interface State {
    homePostIds: number[];
    forumPostsIds: number[];
    contestPostsIds: number[];
    contestTopicId: number;
    wikiExperiencesIds: number[];
    homeCounsellingIds: number[];
    homeStrollerIds: number[];
    photoblogPostsIds: number[];
    loadingState: LoadingState;
    errorMessage: string;
    nextPage: number | null;
    pageLoadingState: LoadingState;
    pageErrorMessage: string;
    lastVisitCountFriends: string;
    bazaarCounts: BazaarCounts;
}

const forumPostsIds = (state: number[] = initialState.forumPostsIds, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.forum.posts;
        default:
            return state;
    }
};

const contestPostsIds = (state: number[] = initialState.contestPostsIds, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.contests.posts;
        default:
            return state;
    }
};

const contestTopicId = (state: number = initialState.contestTopicId, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.contests.topic || state;
        default:
            return state;
    }
};

const wikiExperiencesIds = (state: number[] = initialState.wikiExperiencesIds, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.wiki.experiences;
        default:
            return state;
    }
};

const homeCounsellingIds = (state: number[] = initialState.homeCounsellingIds, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.counselling.counsellings;
        default:
            return state;
    }
};

const homeStrollerIds = (state: number[] = initialState.homeStrollerIds, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.strolleropedia.strollers;
        default:
            return state;
    }
};

const photoblogPostsIds = (state: number[] = initialState.photoblogPostsIds, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.photoblog.posts;
        default:
            return state;
    }
};

const homePostIds = (state: number[] = initialState.homePostIds, action: HomeLoadApiSuccessAction | HomeLoadPageApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.response.result.homepage.posts;
        case HOME_LOAD_PAGE_API_SUCCESS:
            return uniq([ ...state, ...action.response.result.posts ]);
        default:
            return state;
    }
};

const nextPage = (state: (number | null) = initialState.nextPage, action: HomeLoadApiSuccessAction | HomeLoadPageApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
        case HOME_LOAD_PAGE_API_SUCCESS:
            return action.nextPage;
        default:
            return state;
    }
};

const bazaarCounts = (state: BazaarCounts = initialState.bazaarCounts, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.bazaarCounts;
        default:
            return state;
    }
};

const lastVisitCountFriends = (state: (string) = initialState.lastVisitCountFriends, action: HomeLoadApiSuccessAction) => {
    switch (action.type) {
        case HOME_LOAD_API_SUCCESS:
            return action.lastVisitCountFriends;
        default:
            return state;
    }
};

const reducer: Reducer<State> = combineReducers({
    loadingState: loadingStateFiltered('HOME_LOAD_API'),
    errorMessage: errorMessageFiltered('HOME_LOAD_API'),
    pageLoadingState: loadingStateFiltered('HOME_LOAD_PAGE_API'),
    pageErrorMessage: errorMessageFiltered('HOME_LOAD_PAGE_API'),
    forumPostsIds,
    contestPostsIds,
    contestTopicId,
    wikiExperiencesIds,
    photoblogPostsIds,
    homePostIds,
    nextPage,
    bazaarCounts,
    homeCounsellingIds,
    homeStrollerIds,
    lastVisitCountFriends,
});

export default reducer;
